<template>
  <div class="apply-page">
    <div class="columns is-mobile apply-container has-background-white is-centered">
      <div ref="apply-splash" class="column is-6 is-hidden-mobile apply-splash">
        <div class="columns is-centered">
          <div class="column is-8"></div>
        </div>
      </div>
      <div class="column is-fullheight is-6-desktop is-10-mobile">
        <div class="mt-6 columns is-centered">
          <div class="column is-4">
            <img :src="$store.getters['tenant/applyLogoUrl']" alt class="apply-logo" />
          </div>
        </div>

        <div class="columns is-centered">
          <div class="column is-8">
            <h2 class="is-size-3 mb-6 has-text-weight-semibold">
              Register for
              <span class="is-capitalized">{{ fetchedTenant.school_name }}</span>
            </h2>
            <form class="apply-form" @submit.prevent="submit">
              <b-field label="First Name">
                <b-input v-model="user.first_name" autofocus name="first name" placeholder="Bob" required />
              </b-field>
              <b-field label="Last Name">
                <b-input v-model="user.last_name" autofocus name="last name" placeholder="Smith" required />
              </b-field>
              <b-field label="E-mail Address">
                <b-input
                  v-model="user.email"
                  autofocus
                  disabled
                  name="email"
                  placeholder="bobsmith@email.com"
                  required
                  type="email" />
              </b-field>
              <ValidationObserver v-if="newUser" ref="observer">
                <p>Please enter a password below. It must be a minimum of 8 characters</p>
                <b-field label="Password">
                  <ValidationProvider v-slot="{ errors }" rules="required|min|password:@confirm">
                    <b-input v-model="user.password" :password-reveal="true" name="password" type="password" />
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>

                <b-field label="Confirm password">
                  <ValidationProvider v-slot="{ errors }" name="confirm" rules="required">
                    <b-input
                      v-model="user.password_confirmation"
                      :loading="isLoading"
                      :password-reveal="true"
                      type="password" />
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </ValidationObserver>

              <hr />

              <b-field class="pt-3">
                <b-field grouped>
                  <div class="control">
                    <b-button :loading="isLoading" native-type="submit" type="is-primary">Register</b-button>
                  </div>
                </b-field>
              </b-field>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
  import { required } from "vee-validate/dist/rules";
  import Campus from "@/models/sis/Campus";
  import { TenantClient } from "@/clients/Tenant";
  import Invite from "@/models/sis/Invite";

  extend("required", {
    ...required,
    message: "This field is required",
  });
  extend("password", {
    params: ["target"],
    validate(value, { target }) {
      return value === target;
    },
    message: "Password confirmation does not match",
  });
  extend("min", value => {
    if (value.length >= 8) {
      return true;
    }
    return "The password must be at least 8 characters";
  });
  extend("min-items", {
    validate(value, args) {
      return value.length >= args.length;
    },
    params: ["length"],
  });
  export default {
    name: "Register",
    components: { ValidationProvider, ValidationObserver },
    data() {
      return {
        fetchedTenant: Object,
        isLoading: false,
        newUser: true,
        existingUser: false,
        user: {
          first_name: "",
          last_name: "",
          email: "",
          password: null,
          password_confirmation: null,
        },
      };
    },
    created() {
      this.$store.dispatch("loader/showOpaque");

      this.$store.dispatch("menu/fullPage", true);
      this.$store.dispatch("menu/asideRightToggle", false);
    },
    beforeDestroy() {
      this.$store.dispatch("menu/fullPage", false);
    },
    computed: {
      tenant() {
        return this.$route.query.tenant;
      },
      key() {
        return this.$route.query.key;
      },
      email() {
        return this.$route.query.email;
      },
      campuses() {
        return Campus.query()
          .where("name", value => {
            return value !== "";
          })
          .get();
      },
    },

    async mounted() {
      let query = {};
      query.uuid = this.tenant;
      this.user.email = this.email;
      await TenantClient.getTenants(query).then(({ data }) => {
        if (data.length > 0) {
          this.$store.state.tenant.storage = data[0].storage;
          this.$refs["apply-splash"].style.backgroundImage =
            "linear-gradient(180deg,#2218189a 0%,#54545439 50%,#6e6e6e00 100%),url(" +
            this.$store.getters["tenant/applyImage"] +
            ")";
          this.$cookies.set("tenant_storage", data[0].storage);
          this.$cookies.set("tenant_uuid", data[0].uuid);
          this.$store.state.tenant.school_name = data[0].school_name;
          this.$cookies.set("tenant_school_name", data[0].school_name);
          this.$store.state.auth.tenantId = data[0].id;
          this.$cookies.set("tenant_id", data[0].id);
          this.fetchedTenant = data[0];
          this.$store.dispatch("loader/hideOpaque");
          return Promise.resolve();
        } else {
          this.$router.push("/login");
          this.$store.dispatch("loader/hideOpaque");

          return Promise.reject("no-tenants");
        }
      });
    },
    methods: {
      showVideoModal() {
        this.isVideoModalActive = true;
      },
      submit() {
        this.isLoading = true;

        Invite.Accept(
          {
            email: this.user.email,
            password: this.user.password,
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            tenant_uuid: this.tenant,
            key: this.key,
          },
          this.$store.state.auth.tenantId,
        )
          .then(() => {
            this.isLoading = false;
            this.$store.dispatch("loader/hide");
            setTimeout(() => {
              this.$router.push({ name: "login" });
            }, 4999);
            this.$buefy.snackbar.open({
              message: "Registration Successful. You will now be redirected to login",
              type: "is-link",
              position: "is-top",
              actionText: "Go To Login",
              duration: 5000,
              onAction: () => {
                this.$router.push({ name: "login" });
              },
            });
          })
          .catch(err => {
            this.handleError(err);
            this.isLoading = false;
            this.$store.dispatch("loader/hide");
          });
      },
    },
  };
</script>
